import { useState } from "react"
import { Container } from "reactstrap"
import Tabs from "../../../../components/common/Tabs/Tabs"
import CurrentSubscription from "./CurrentSubscription/CurrentSubscription"
import OtherPlatformSubscription from "./OtherPlatformSubscription/OtherPlatformSubscription"

const Subscription = () => {

  const tabs = ['Current Subscription', 'Other Platform Subscriptions']
  const [activeTab, setActiveTab] = useState(tabs[0])

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", paddingBlock: "1rem" }}>
      <Container fluid>
        <div className="fw-semibold fs-4">Subscriptions</div>

        <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />

        {activeTab === 'Current Subscription' && <CurrentSubscription />}
        {activeTab === 'Other Platform Subscriptions' && <OtherPlatformSubscription />}

      </Container>
    </div>
  )
}

export default Subscription
